import React, { useContext } from 'react';
import style from './style.css';
import { FlowContext } from '../../core/flow-engine';
import Heading from '../Typography/Heading/Heading';
import AllocationTotalInput from '../AllocationTotalInput/AllocationTotalInput';
import { isContributory } from '../../flows/shared/utils';

const BuildPortfolioHeader = () => {
  const { appState } = useContext(FlowContext);
  const {
    store: { accountType }
  } = appState;

  return (
    <div
      data-e2e="byop-header"
      className="build-portfolio-header"
      id="build-portfolio-header">
      <Heading text="Select Investments" />
      {isContributory(accountType) ? (
        <span className="fund-later-sub">
          Select one or more mutual funds from the list below for your
          investments.
        </span>
      ) : (
        <AllocationTotalInput accountType={accountType} />
      )}
      <style jsx>{style}</style>
    </div>
  );
};

export default BuildPortfolioHeader;
